/**
* Define all of your application routes here
* for more information on routes, see the
* official documentation https://router.vuejs.org/en/
*/

import api from '@/_api'
let TipoPerfilOperador = api.Arrays.TipoPerfilOperador
export default [
  {
    title: 'Dashboard',
    icon: 'fas fa-home',
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/app/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Nenhum],
      allRolesRequired: false
    }
  },
  {
    title: 'Admin',
    icon: 'fas fa-cog',
    path: '/admin/',
    dir: 'views/app/admin/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Antifraude],
      allRolesRequired: false
    },
    items: [
      {
        path: 'operacao',
        view: 'Operacao',
        title: 'Operação',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        path: 'operador',
        view: 'Operador',
        title: 'Operador',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        path: 'audittrail',
        view: 'AuditTrail',
        title: 'Audit Trail',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        path: 'pendenciaenviocm',
        view: 'PendenciaEnvioCM',
        title: 'Envio CM',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        path: 'tarifario',
        view: 'Tarifario',
        title: 'Tarifário',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        path: 'tarifarecorrente',
        view: 'TarifaRecorrente',
        title: 'Tarifa Recorrente',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        path: 'split  ',
        view: 'Split',
        title: 'Split',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        path: 'versaoappfrontend',
        view: 'VersaoAppFrontend',
        title: 'Versões App Frontend',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        title: 'Limites',
        icon: 'fas fa-lock',
        path: 'limite/',
        dir: 'limite/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        },
        items: [
          {
            path: 'operador/',
            title: 'Operador',
            dir: 'operador/',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: false
            },
            items: [
              {
                path: 'cadastrar',
                view: 'LimiteOperador',
                title: 'Cadastrar',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Administrador],
                  allRolesRequired: true
                }
              },
              {
                path: 'adicional',
                view: 'LimiteAdicionalOperador',
                title: 'Adicional',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Administrador],
                  allRolesRequired: false
                }
              }
            ]
          },
          {
            path: 'operacao/',
            title: 'Operação',
            dir: 'operacao/',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: false
            },
            items: [
              {
                path: 'cadastrar',
                view: 'LimiteOperacao',
                title: 'Cadastrar',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Administrador],
                  allRolesRequired: true
                }
              },
              {
                path: 'adicional',
                view: 'LimiteAdicional',
                title: 'Adicional',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Administrador],
                  allRolesRequired: false
                }
              },
              {
                path: 'aprovacao',
                view: 'LimiteAprovacao',
                title: 'Importação Limites',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Administrador],
                  allRolesRequired: true
                }
              },
              {
                path: 'download',
                view: 'DownloadModeloImportacao',
                title: 'Download Modelo Importação',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Administrador],
                  allRolesRequired: true
                }
              }
            ]
          },
          {
            path: 'consultar/',
            title: 'Consultar',
            dir: 'consultar/',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: false
            },
            items: [
              {
                path: 'cartao',
                view: 'ConsultaLimiteContas',
                title: 'Consultar Limites Cartão',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Administrador],
                  allRolesRequired: true
                }
              },
              {
                path: 'consultar',
                view: 'ConsultaLimitesPix',
                title: 'Consultar Limites Pix',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
                  allRolesRequired: false
                }
              },
              {
                path: 'solicitacoes',
                view: 'SolicitacoesLimiteOperacao',
                title: 'Solicitações Limite Operação',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master],
                  allRolesRequired: false
                }
              }
            ]
          }
        ]
      },
      {
        title: 'Segurança',
        icon: 'fas fa-lock',
        path: 'seguranca/',
        dir: 'seguranca/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        },
        items: [
          {
            path: 'clients',
            view: 'Client',
            title: 'Clientes API',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          }
        ]
      },
      {
        title: 'Retaguarda',
        icon: 'fas fa-lock',
        path: 'retaguarda/',
        dir: 'retaguarda/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        },
        items: [
          {
            path: 'operadorretaguarda',
            view: 'OperadorRetaguarda',
            title: 'Operador Retaguarda',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          },
          {
            path: 'solicitacaoOperadorRetaguardaMfa',
            view: 'SolicitacaoOperadorRetaguardaMfa',
            title: 'Solicitação MFA Retaguarda',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            }
          },
          {
            path: 'operadorFrontEnd',
            view: 'OperadorFrontEnd/OperadorFrontEnd',
            title: 'Operador Frontend',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Antifraude],
              allRolesRequired: false
            }
          },
          {
            path: 'perfilfrontend',
            view: 'PerfilFrontend',
            title: 'Perfil Frontend',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          },
          {
            path: 'operador-onboarding-externo',
            view: 'OperadorOnboardingExterno/OperadorOnboardingExterno',
            title: 'Operador Onboarding Externo',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          }
        ]
      },
      {
        title: 'Onboarding',
        icon: 'fas fa-lock',
        path: 'onboarding/',
        dir: 'onboarding/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        },
        items: [
          {
            path: 'operador-onboarding',
            view: 'OperadorOnboarding',
            title: 'Operador Onboarding',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          }
        ]
      },
      {
        title: 'CMS',
        icon: 'fas fa-lock',
        path: 'cms/',
        dir: 'cms/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        },
        items: [
          {
            path: 'operador-cms',
            view: 'Operador',
            title: 'Operador',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          }
        ]
      },
      {
        title: 'Mensagens CCS',
        icon: 'fas fa-envelope-open-text',
        path: 'mensagensccs/',
        dir: 'mensagensccs/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        },
        items: [
          {
            path: 'solicitacaoccs',
            view: 'SolicitacaoCCS',
            title: 'Logs Solicitações CCS',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          }
        ]
      },
    ]
  },
  {
    title: 'Segurança',
    icon: 'fas fa-shield-alt',
    path: '/seguranca/',
    dir: 'views/app/seguranca/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Analise, TipoPerfilOperador.Seguranca, TipoPerfilOperador.Administrador],
      allRolesRequired: false
    },
    items: [
      {
        path: 'analiseCadastral',
        view: 'AnaliseCadastral',
        title: 'Análise Cadastral',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Analise],
          allRolesRequired: true
        }
      },
      {
        path: 'permissaoAnaliseCadastral',
        view: 'PermissaoAnaliseCadastral',
        title: 'Permissão Análise Cadastral',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Seguranca],
          allRolesRequired: true
        }
      },
      {
        path: 'solicitacaochaveseguranca',
        view: 'SolicitacaoChaveSeguranca',
        title: 'Solicitação Chave de Segurança',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Seguranca],
          allRolesRequired: true
        }
      },
      {
        path: 'solicitacaoSenhaEletronica',
        view: 'SenhaEletronica/SolicitacaoSenhaEletronica',
        title: 'Solicitação Senha Eletrônica',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Analise],
          allRolesRequired: false
        }
      },
      {
        title: 'Protocolo Rede',
        path: 'protocolorede/',
        dir: 'ProtocoloRede/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: false
        },
        items: [
          {
            path: 'retaguarda',
            view: 'Retaguarda/ParceiroIP',
            title: 'Retaguarda',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: false
            }
          },
          {
            path: 'externa',
            view: 'Externa/ParceiroIP',
            title: 'API Externa',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: false
            }
          },
        ],
      },
      {
        title: 'Gestão de Acessos',
        path: 'gestao-acessos/',
        dir: 'GestaoAcessos/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: false
        },
        items: [
          {
            path: 'desbloqueio-usuarios',
            view: 'DesbloqueioUsuarios',
            title: 'Desbloqueio de usuários',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
        ],
      },
      {
        title: 'Histórico',
        path: 'historico/',
        dir: 'Historico/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: false
        },
        items: [
          {
            path: 'desbloqueio-usuarios',
            view: 'DesbloqueioUsuarios',
            title: 'Desbloqueio de usuários',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
        ],
      }
    ]
  },
  {
    title: 'Cadastros',
    icon: 'fas fa-edit',
    path: '/cadastros/',
    dir: 'views/app/cadastros/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
      allRolesRequired: false
    },
    items: [
      {
        path: 'banco',
        view: 'Banco',
        title: 'Bancos',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'finalidades',
        view: 'FinalidadeTransferencia',
        title: 'Finalidades de Transferência',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'participantespi',
        view: 'ParticipanteSPI',
        title: 'Participantes SPI',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'agencia',
        view: 'Agencia',
        title: 'Agências',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'conta',
        view: 'Conta/Conta',
        title: 'Contas',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'correntista',
        view: 'Correntista',
        title: 'Correntistas',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'contareserva',
        view: 'ContaReserva',
        title: 'Contas Reserva',
        params: true,
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'parceiro',
        view: 'Parceiro/Parceiro',
        title: 'Parceiros',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'feriado',
        view: 'Feriado',
        title: 'Feriados',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'carteira',
        view: 'Carteira',
        title: 'Carteiras',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'cedente',
        view: 'Cedente',
        title: 'Cedente',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice],
          allRolesRequired: false
        }
      },
      {
        path: 'cedentecarteira',
        view: 'CedenteCarteira',
        title: 'Cedentes x Carteiras',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'schedulerregboleto',
        view: 'SchedulerRegBoleto',
        title: 'Agendamento Registro Boleto',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'contatransitoria',
        view: 'ContasTransitorias',
        title: 'Contas Transitórias',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'administrador-contas',
        view: 'AdministradorContas',
        title: 'Administrador Contas',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        path: 'administrar-carteira-contas',
        view: 'CarteiraContas',
        title: 'Carteira Contas',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        }
      },
      {
        path: 'permissaoliberacaoespecial',
        view: 'PermissaoLiberacaoEspecial/PermissaoLiberacaoEspecial',
        title: 'Liberação Especial CAAS',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        title: 'Comunicação',
        path: 'comunicacao/',
        dir: 'comunicacao/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        },
        items: [
          {
            path: 'enviodeemail',
            view: 'EnvioDeEmail',
            title: 'Envio de E-mail',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          },
          {
            path: 'templatenotificacao',
            view: 'TemplateNotificacao',
            title: 'Push Notification Template',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          },
          {
            path: 'notificacao',
            view: 'Notificacao',
            title: 'Informativos',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          }
        ]
      }
    ]
  },
  {
    title: 'Consultas',
    icon: 'fas fa-search',
    path: '/consultas/',
    dir: 'views/app/consultas/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Antifraude],
      allRolesRequired: false
    },
    items: [
      {
        path: 'extratoconta',
        view: 'Extrato',
        title: 'Extrato',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'agendamentos',
        view: 'Agendamentos',
        title: 'Transações Agendadas',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'aprovacoes',
        view: 'Aprovacoes',
        title: 'Aprovações de Transações',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      }
    ]
  },
  {
    title: 'Processos',
    icon: 'fas fa-tasks',
    path: '/processos/',
    dir: 'views/app/processos/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
      allRolesRequired: false
    },
    items: [
      {
        path: 'boletopag',
        view: 'BoletoPag',
        title: 'Pagamento de Boleto',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'transferencia/',
        dir: 'transferencia/',
        title: 'Transferência',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        },
        items: [
          {
            path: 'transferir',
            view: 'Transferencia',
            title: 'Transferir',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
          {
            path: 'transferirdepositojudicial',
            view: 'TransferenciaDepositoJudicial',
            title: 'Transferir - Depósito Judicial',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
          {
            path: 'importar',
            view: 'Importar',
            title: 'Importar',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Consulta, TipoPerfilOperador.Administrador, TipoPerfilOperador.Master],
              allRolesRequired: false
            }
          },
          {
            path: 'exportar',
            view: 'Exportar',
            title: 'Histórico',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Consulta, TipoPerfilOperador.Administrador, TipoPerfilOperador.Master],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: 'movmanual',
        view: 'MovManual',
        title: 'Movimento Manual',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'comprovante',
        view: 'Comprovante',
        title: '2ª Via de Comprovantes',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'cnab/',
        title: 'CNAB',
        dir: 'cnab/',
        menu: true,
        meta: {
          roles: [
            TipoPerfilOperador.Operador,
            TipoPerfilOperador.Administrador,
            TipoPerfilOperador.Backoffice
          ],
          allRolesRequired: false
        },
        items: [
          {
            path: '240/',
            title: '240',
            dir: '240/',
            menu: true,
            meta: {
              roles: [
                TipoPerfilOperador.Operador,
                TipoPerfilOperador.Administrador,
                TipoPerfilOperador.Backoffice
              ],
              allRolesRequired: false
            },
            items: [
              {
                path: 'importacao',
                view: 'Importacao',
                title: 'Importação',
                menu: true,
                meta: {
                  roles: [
                    TipoPerfilOperador.Operador,
                    TipoPerfilOperador.Administrador,
                    TipoPerfilOperador.Backoffice
                  ],
                  allRolesRequired: false
                }
              },
              {
                path: 'exportacao',
                view: 'Exportacao',
                title: 'Exportação',
                menu: true,
                meta: {
                  roles: [
                    TipoPerfilOperador.Operador,
                    TipoPerfilOperador.Administrador,
                    TipoPerfilOperador.Backoffice
                  ],
                  allRolesRequired: false
                }
              },
              {
                path: 'consultalog',
                view: 'ConsultaLog',
                title: 'Consulta de Log',
                menu: true,
                meta: {
                  roles: [
                    TipoPerfilOperador.Operador,
                    TipoPerfilOperador.Administrador,
                    TipoPerfilOperador.Backoffice
                  ],
                  allRolesRequired: false
                }
              }
            ]
          },
          {
            path: '400/',
            title: '400',
            dir: '400/',
            menu: true,
            meta: {
              roles: [
                TipoPerfilOperador.Operador,
                TipoPerfilOperador.Administrador,
                TipoPerfilOperador.Backoffice
              ],
              allRolesRequired: false
            },
            items: [
              {
                path: 'importacao',
                view: 'Importacao',
                title: 'Importação',
                menu: true,
                meta: {
                  roles: [
                    TipoPerfilOperador.Operador,
                    TipoPerfilOperador.Administrador,
                    TipoPerfilOperador.Backoffice
                  ],
                  allRolesRequired: false
                }
              },
              {
                path: 'exportacao',
                view: 'Exportacao',
                title: 'Exportação',
                menu: true,
                meta: {
                  roles: [
                    TipoPerfilOperador.Operador,
                    TipoPerfilOperador.Administrador,
                    TipoPerfilOperador.Backoffice
                  ],
                  allRolesRequired: false
                }
              },
              {
                path: 'transferenciacedenteaprovados',
                view: 'TransferenciaCedenteAprovados',
                title: 'Transferência de cedente - Aprovados',
                menu: true,
                meta: {
                  roles: [
                    TipoPerfilOperador.Operador,
                    TipoPerfilOperador.Administrador,
                    TipoPerfilOperador.Backoffice
                  ],
                  allRolesRequired: false
                }
              }
            ]
          }
        ]
      },
      {
        path: 'transferenciacontareserva',
        view: 'TransferenciaContaReserva',
        title: 'Transferência Conta Reserva',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'baixaregistroboleto',
        view: 'BaixaRegistroBoleto',
        title: 'Baixa Efetiva',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        }
      },
      {
        path: 'divergencias',
        view: 'Divergencias',
        title: 'Divergências',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        title: 'Bloqueio de Saldo',
        path: 'bloqueiosaldo/',
        dir: 'BloqueioSaldo/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: false
        },
        items: [
          {
            path: 'manual',
            view: 'BloqueioManual',
            title: 'Manual',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: false
            }
          },
          {
            path: 'automatico',
            view: 'BloqueioAutomatico',
            title: 'Automático',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: false
            }
          },
          {
            path: 'bloqueiocontaemlote',
            view: 'BloqueioContaLote',
            title: 'Bloqueio Conta em Lote',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: 'cobrancaspendentes',
        view: 'CobrancasPendentes/Page',
        title: 'Cobranças Pendentes',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        path: 'repassetarifa',
        view: 'RepasseTarifas',
        title: 'Repasse Comissão Tarifário',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: false
        }
      },
      {
        path: 'swap/',
        title: 'Swap',
        dir: 'Swap/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
          allRolesRequired: false
        },
        items: [
          {
            path: 'aprovacaosolicitacaocartao',
            view: 'AprovacaoSolicCartao',
            title: 'Aprovação Solicitação Cartão',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
          {
            path: 'saldoSwap',
            view: 'SaldoSwap',
            title: 'Saldo SWAP',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
          {
            path: 'logTransacional',
            view: 'LogTransacional',
            title: 'Log transacional',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: 'limiteespecial/',
        dir: 'limiteespecial/',
        title: 'Limite especial',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        },
        items: [
          {
            path: 'cancelarlimiteespecial',
            view: 'CancelarLimiteEspecial',
            title: 'Cancelar Limite Especial',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador],
              allRolesRequired: true
            }
          },
        ]
      }
    ]
  },
  {
    title: 'Boletos',
    icon: 'fas fa-file-invoice-dollar',
    path: '/dda/',
    dir: 'views/app/dda/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
      allRolesRequired: false
    },
    items: [
      {
        path: 'registroboleto',
        view: 'RegistroBoleto',
        title: 'Registro Boleto',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice],
          allRolesRequired: false
        }
      },
      {
        path: 'consultaboleto',
        view: 'ConsultaBoleto',
        title: 'Consulta Boleto',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'consultaboletocip',
        view: 'ConsultaBoletoCip',
        title: 'Consulta Boleto - CIP',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'alteracaoboleto',
        view: 'AlteracaoBoleto',
        title: 'Alteração Boleto',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice],
          allRolesRequired: false
        }
      },
      {
        path: 'cancelarboletos',
        view: 'BaixaBoletos',
        title: 'Cancelar Boletos',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice],
          allRolesRequired: false
        }
      },
      {
        path: 'boletosdevolvidos',
        view: 'BoletosDevolvidos/BoletosDevolvidos',
        title: 'Boletos Devolvidos',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice],
          allRolesRequired: false
        }
      },
      {
        title: 'Protesto de Boleto',
        path: 'protesto-boleto/',
        dir: 'protestoBoleto/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice],
          allRolesRequired: false
        },
        items: [
          {
            path: 'protestar',
            view: 'ProtestoBoleto',
            title: 'Protesto',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador],
              allRolesRequired: false
            }
          },
          {
            path: 'consultar',
            view: 'ConsultaProtestoBoleto',
            title: 'Consulta',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice],
              allRolesRequired: false
            }
          },
          {
            path: 'liquidados',
            view: 'ProtestoBoletoLiquidado',
            title: 'Liquidação de Boletos Protestados',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: 'pagadoreletronico/',
        dir: 'pagadoreletronico/',
        title: 'DDA - Pagador Eletrônico',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: true
        },
        items: [
          {
            path: 'adesao',
            view: 'Adesao',
            title: 'Adesão',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador],
              allRolesRequired: true
            }
          },
          {
            path: 'consulta',
            view: 'Consulta',
            title: 'Consulta',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador],
              allRolesRequired: true
            }
          },
        ]
      },
      {
        path: 'cessaoboleto',
        view: 'CessaoBoleto/CessaoBoleto',
        title: 'Transferência Cedente',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'monitorrelatorioconsolidadocredito',
        view: 'MonitorRelatorioConsolidadoCredito',
        title: 'Relatório Crédito Consolidado',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice],
          allRolesRequired: false
        }
      }
    ]
  },
  {
    title: 'PIX',
    icon: 'fas fa-desktop',
    path: '/pix/',
    dir: 'views/app/pix/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
      allRolesRequired: false
    },
    items: [
      {
        title: 'Chaves',
        icon: 'fas fa-key',
        path: 'chaves/',
        dir: 'chaves/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        },
        items: [
          {
            path: 'Cadastro',
            view: 'ChavesPix',
            title: 'Cadastrar',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Operador],
              allRolesRequired: false
            }
          },
          {
            path: 'consultar',
            view: 'ConsultarChavesPixConta',
            title: 'Consultar',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        title: 'Recursos',
        icon: 'fas fa-lock',
        path: 'recursos/',
        dir: 'recursos/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Operador],
          allRolesRequired: false
        },
        items: [
          {
            path: 'enviar',
            view: 'EnviarPix',
            title: 'Enviar',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
          {
            path: 'devolver',
            view: 'DevolverPix',
            title: 'Devolver',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
          {
            path: 'contasreservaspix',
            view: 'ContasReservasPix',
            title: 'Contas Reservas',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
          {
            path: 'consultapixcobranca',
            view: 'ConsultaPixCobranca',
            title: 'Consulta QRCode Dinâmico',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        title: 'QRCode',
        icon: 'fas fa-qrcode',
        path: 'qrcode/',
        dir: 'qrcode/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Operador],
          allRolesRequired: false
        },
        items: [
          {
            path: 'qrcodeestatico',
            view: 'QRCodeEstatico',
            title: 'Estático',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          },
          {
            path: 'qrcodedinamico',
            view: 'QRCodeDinamico',
            title: 'Dinâmico',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        title: 'Portabilidade',
        icon: 'fas fa-exchange-alt',
        path: 'portabilidade/',
        dir: 'portabilidade/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador],
          allRolesRequired: false
        },
        items: [
          {
            path: 'solicitareivindicacao',
            view: 'SolicitarPortabilidade',
            title: 'Solicitar',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador],
              allRolesRequired: false
            }
          },
          {
            path: 'solicitacoesefetuadas',
            view: 'SolicitacoesEfetuadas',
            title: 'Solicitações Efetuadas',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador],
              allRolesRequired: false
            }
          },
          {
            path: 'solicitacoesrecebidas',
            view: 'SolicitacoesRecebidas',
            title: 'Solicitações Recebidas',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        title: 'Fraude',
        icon: 'fas fa-hand-holding-usd',
        path: 'fraude/',
        dir: 'fraude/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        },
        items: [
          {
            title: 'Infração',
            icon: 'fas fa-exclamation-triangle',
            path: 'infracao/',
            dir: 'infracao/',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
              allRolesRequired: false
            },
            items: [
              {
                path: 'notificar',
                view: 'Notificar',
                title: 'Notificar',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
                  allRolesRequired: false
                }
              },
              {
                path: 'notificacoesenviadas',
                view: 'NotificacoesEnviadas',
                title: 'Notificações Enviadas',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
                  allRolesRequired: false
                }
              },
              {
                path: 'notificacoesrecebidas',
                view: 'NotificaoesRecebidas',
                title: 'Notificações Recebidas',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
                  allRolesRequired: false
                }
              }
            ]
          },
          {
            title: 'Devolução',
            icon: 'fas fa-undo-alt',
            path: 'devolucao/',
            dir: 'devolucao/',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
              allRolesRequired: false
            },
            items: [
              {
                path: 'solicitar',
                view: 'Solicitar',
                title: 'Solicitar',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
                  allRolesRequired: false
                }
              },
              {
                path: 'solicitacoesefetuadas',
                view: 'SolicitacoesEfetuadas',
                title: 'Solicitações Enviadas',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
                  allRolesRequired: false
                }
              },
              {
                path: 'solicitacoesrecebidas',
                view: 'SolicitacoesRecebidas',
                title: 'Solicitações Recebidas',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
                  allRolesRequired: false
                }
              }
            ]
          },
          {
            title: 'Cancelar marcação DICT',
            icon: 'fas fa-times-circle',
            path: 'marcacao',
            view: 'marcacao/CancelarMarcacaoDict',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
              allRolesRequired: false
            }

          },
          {
            title: 'Recuperação de Valores',
            icon: 'fas fa-exclamation-triangle',
            path: 'recuperacaovalores/',
            dir: 'recuperacaovalores/',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            },
            items: [
              {
                path: 'parametrizacao',
                view: 'parametrizacao/ParametrizacaoRecuperacaoValores',
                title: 'Parametrização',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Administrador],
                  allRolesRequired: false
                }
              },
              {
                path: 'solicitacao',
                view: 'solicitacao/SolicitarRecuperacao',
                title: 'Solicitar Recuperação',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Administrador],
                  allRolesRequired: false
                }
              },
              {
                path: 'recuperacoesenviadas',
                view: 'solicitacao/RecuperacoesEnviadas',
                title: 'Recuperações Enviadas',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Administrador],
                  allRolesRequired: false
                },
              }
            ]
          },
        ]
      },
      {
        title: 'Outros',
        icon: 'fas fa-cogs',
        path: 'outros/',
        dir: 'outros/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        },
        items: [
          {
            path: 'testeconexao',
            view: 'TesteConexao',
            title: 'Teste Conexão',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
              allRolesRequired: false
            }
          },
          {
            path: 'exportartempospix',
            view: 'ExportTemposPix',
            title: 'Exportar Tempos PIX',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador],
              allRolesRequired: false
            }
          }
        ]
      }
    ]
  },
  {
    title: 'Antifraude',
    icon: 'fas fa-user-shield',
    path: '/antifraude/',
    dir: 'views/app/antifraude/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Master, TipoPerfilOperador.Seguranca, TipoPerfilOperador.Antifraude],
      allRolesRequired: false
    },
    items: [
      {
        path: 'cadastrolistapositiva',
        view: 'CadastroListaPositiva/CadastroListaPositiva',
        title: 'Cadastro Lista Positiva BMP Prevenção a Fraudes',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Master, TipoPerfilOperador.Seguranca, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'listapositivaexclusao',
        view: 'ListaPositivaExclusao',
        title: 'Exclusões Lista Positiva BMP Prevenção a Fraudes',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Master, TipoPerfilOperador.Seguranca, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatoriomarcacaofraude',
        view: 'RelatorioMarcacaoFraude',
        title: 'Relatório de Marcação de Fraude',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'consultamarcacaofraude',
        view: 'ConsultaMarcacaoFraude',
        title: 'Consultar Marcação de Fraude',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatoriotransacoesbloqueadas',
        view: 'RelatorioTransacoesBloqueadas',
        title: 'BMP Log de Transações Alertadas',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Master, TipoPerfilOperador.Seguranca, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'parametrizacaoalertafraude',
        view: 'ParametrizacaoAlertaFraude/ParametrizacaoAlertaFraude',
        title: 'Parametrizacao Alerta Fraude',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Master, TipoPerfilOperador.Seguranca, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'configuracoesfraude',
        view: 'Configuracoes/ConfiguracoesFraude',
        title: 'Configurações',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Master, TipoPerfilOperador.Seguranca, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'logparametrizacaoalertafraude',
        view: 'ParametrizacaoAlertaFraude/ParametrizacaoAlertaFraudeLog',
        title: 'Log Parametrizacao Alerta Fraude',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Master, TipoPerfilOperador.Seguranca, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
    ]
  },
  {
    title: 'Consulta Operacional',
    icon: 'fas fa-briefcase',
    path: '/consultaoperacional/',
    dir: 'views/app/consultaoperacional/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Contabil, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
      allRolesRequired: false
    },
    items: [
      {
        path: 'movporconta',
        view: 'MovPorConta',
        title: 'Movimentações por Conta',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatoriosaldo',
        view: 'RelatorioSaldo',
        title: 'Relatório de Saldo',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatorioSaldoPorParceiro',
        view: 'RelatorioSaldoPorParceiro',
        title: 'Relatório de Saldo por Parceiro',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatorioboletoregistrado',
        view: 'RelatorioBoletoRegistrado',
        title: 'Relatório de Boletos Registrados',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatoriocontas',
        view: 'RelatorioContas',
        title: 'Relatório de Contas',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatoriodivergenciascontas',
        view: 'RelatorioDivergenciasContas',
        title: 'Divergências Cadastrais',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'monitormovimentacao',
        view: 'MonitorMovimentacao',
        title: 'Monitor Movimentação',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatoriotarifariomensal',
        view: 'RelatorioTarifarioMensal',
        title: 'Relatório Tarifa Recorrente',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatorio-bc-protege-mais',
        view: 'RelatorioBCProtegeMais',
        title: 'Relatório BC Protege+',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'relatorio-recusas',
        view: 'RelatorioRecusas',
        title: 'Relatório de Recusas',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        title: 'Exportação BACEN',
        path: 'bacen/',
        dir: 'bacen/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        },
        items: [
          {
            path: 'parametrizacao',
            view: 'Parametrizacao',
            title: 'Parametrização',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil, TipoPerfilOperador.Antifraude],
              allRolesRequired: false
            }
          },
          {
            path: 'solicitar',
            view: 'Solicitar',
            title: 'Solicitar',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil, TipoPerfilOperador.Antifraude],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: 'downloadRelatorio',
        view: 'DownloadRelatorio',
        title: 'Download Relatório',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Contabil, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'limiteConsultaBoleto',
        view: 'LimiteConsultaBoleto',
        title: 'Limite Consulta Boletos',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Operador, TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta, TipoPerfilOperador.Contabil, TipoPerfilOperador.Backoffice, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'consultafavorecidos',
        view: 'ConsultaFavorecidos',
        title: 'Favorecidos',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      }
    ]
  },
  {
    title: 'Exportação Contabilização',
    icon: 'fas fa-file-invoice',
    path: '/contabil/',
    dir: 'views/app/contabil/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
      allRolesRequired: false
    },
    items: [
      {
        title: 'Parametrização',
        icon: 'fas fa-tools',
        path: 'parametrizacao/',
        dir: 'parametrizacao/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
          allRolesRequired: false
        },
        items: [
          {
            path: 'global',
            view: 'Global',
            title: 'Global',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
              allRolesRequired: false
            }
          },
          {
            path: 'custeio',
            view: 'Custeio',
            title: 'Custeio',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
              allRolesRequired: false
            }
          },
          {
            path: 'contaPagamento',
            view: 'CtbContaPagamento',
            title: 'Conta Pagamento',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
              allRolesRequired: false
            }
          },
          {
            path: 'ctbParceiro',
            view: 'CtbParceiro',
            title: 'Parceiro',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
              allRolesRequired: false
            }
          },
          {
            path: 'ctboperacao',
            view: 'CtbOperacao',
            title: 'Operação',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
              allRolesRequired: false
            }
          },
          {
            path: 'contasMigradas',
            view: 'ContasMigradas',
            title: 'Contas Migradas',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
              allRolesRequired: false
            }
          }
        ]
      },
      {
        title: 'Processos',
        icon: 'fas fa-tasks',
        path: 'processos/',
        dir: 'processos/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
          allRolesRequired: false
        },
        items: [
          {
            path: 'exportacao',
            view: 'Exportacao',
            title: 'Geração Arquivo CSV',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Contabil],
              allRolesRequired: false
            }
          }
        ]
      }
    ]
  },
  {
    title: 'Monitor',
    icon: 'fas fa-desktop',
    path: '/monitor/',
    dir: 'views/app/monitor/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
      allRolesRequired: false
    },
    items: [
      {
        path: 'queueenvio',
        view: 'QueueEnvio',
        title: 'Queue Envio',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        path: 'queueretorno',
        view: 'QueueRetorno',
        title: 'Queue Retorno',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        path: 'queueEnviopix',
        view: 'QueueEnvioPix',
        title: 'Queue Envio PIX',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        path: 'queueRetornopix',
        view: 'QueueRetornoPix',
        title: 'Queue Retorno PIX',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        path: 'volumetria',
        view: 'Volumetria',
        title: 'Volumetria',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        path: 'queuecallback',
        view: 'QueueCallBack',
        title: 'Queue Callback',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        path: 'statusservico',
        view: 'StatusServico',
        title: 'Status Serviço',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        path: 'handshake',
        view: 'Handshake',
        title: 'Handshake',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      },
      {
        path: 'monitoradda',
        view: 'MonitorADDA',
        title: 'Monitor ADDA',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador, TipoPerfilOperador.Consulta],
          allRolesRequired: false
        }
      }
    ]
  },
  {
    title: 'Gerenciar Contas',
    icon: 'fas fa-user-cog',
    path: '/gerenciarcontas/',
    dir: 'views/app/gestaocontas/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
      allRolesRequired: false
    },
    items: [
      {
        path: 'cadastroRestritivo',
        view: 'CadastroRestritivo',
        title: 'Cadastro Restritivo',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Antifraude],
          allRolesRequired: false
        }
      },
      {
        path: 'encerramentoConta',
        view: 'EncerramentoConta',
        title: 'Encerramento Conta',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'solicitacaoEncerramentoContaLote',
        view: 'EncerramentoContaLote/SolicitacaoEncerramentoContaLote',
        title: 'Solicitar Encerramento Lote',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'favorecidos',
        dir: 'CadastroFavorecidos',
        title: 'Favorecidos',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Administrador],
          allRolesRequired: true
        },
        items: [
          {
            path: 'individual',
            view: '/Individual/CadastroFavorecidos',
            title: 'Cadastro Individual',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            }
          },
          {
            path: 'lote',
            view: '/Lote/CadastroFavorecidoLote',
            title: 'Cadastro em Lote',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Administrador],
              allRolesRequired: true
            }
          }
        ]
      },
      {
        path: 'migracaoparceiroconta/',
        title: 'Migração Parceiro',
        dir: 'MigracaoParceiroConta/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        },
        items: [
          {
            path: 'migracaoparceiroconta',
            view: 'MigracaoParceiroConta',
            title: 'Migração Parceiro Individual',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            }
          }, {
            path: 'migracaoparceirocontaemlote',
            view: 'MigracaoParceiroContaLote',
            title: 'Migração Parceiro em Lote',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            }
          }
        ]
      },
      {
        path: 'transferenciaprogramada/',
        title: 'Transferência Programada',
        dir: 'TransferenciaProgramada/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        },
        items: [
          {
            path: 'geral',
            view: 'Geral/RepasseSaldoConta',
            title: 'Geral',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            }
          },
          {
            path: 'transacional',
            view: 'Transacional/RepasseSaldoContaTransacional',
            title: 'Transacional',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            }
          },
          {
            path: 'logs',
            title: 'Logs',
            dir: 'Logs/',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            },
            items: [
              {
                path: 'geral',
                view: 'LogsTransferenciaGeral',
                title: 'Geral',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master],
                  allRolesRequired: true
                }
              }
            ]
          },
        ]
      },
    ]
  },
  {
    title: 'Histórico de Alterações',
    icon: 'fas fa-history',
    path: '/historico/',
    dir: 'views/app/historico/',
    menu: true,
    meta: {
      roles: [TipoPerfilOperador.Master, TipoPerfilOperador.Seguranca],
      allRolesRequired: false
    },
    items: [
      {
        title: 'Limites',
        path: 'limites/',
        dir: 'limites/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: false
        },
        items: [
          {
            title: 'Operação',
            path: 'operacao/',
            dir: 'operacao/',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: false
            },
            items: [
              {
                path: 'consultar',
                view: 'HistoricoLimiteOperacao',
                title: 'Limite Operação',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master],
                  allRolesRequired: true
                }
              },
              {
                path: 'adicional',
                view: 'HistoricoLimiteAdicional',
                title: 'Limite Adicional',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master],
                  allRolesRequired: true
                }
              }
            ]
          },
          {
            title: 'Operador',
            path: 'operador/',
            dir: 'operador/',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: false
            },
            items: [
              {
                path: 'consultar',
                view: 'HistoricoLimiteOperador',
                title: 'Limite Operador',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master],
                  allRolesRequired: true
                }
              },
              {
                path: 'adicional',
                view: 'HistoricoLimiteOperadorAdicional',
                title: 'Limite Operador Adicional',
                menu: true,
                meta: {
                  roles: [TipoPerfilOperador.Master],
                  allRolesRequired: true
                }
              }
            ]
          }
        ]
      },
      {
        title: 'Subparceiros',
        path: 'subparceiros/',
        dir: 'subparceiros/',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: false
        },
        items: [
          {
            path: 'HistoricoSubparceiro',
            view: 'HistoricoSubparceiro',
            title: 'Cadastro',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            }
          },
          {
            path: 'HistoricoOperadorRetaguardaSubparceiro',
            view: 'HistoricoOperadorRetaguardaSubparceiro',
            title: 'Operador Retaguarda',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            }
          },
          {
            path: 'HistoricoVinculoContas',
            view: 'HistoricoVinculoContas',
            title: 'Contas',
            menu: true,
            meta: {
              roles: [TipoPerfilOperador.Master],
              allRolesRequired: true
            }
          },
        ]
      },
      {
        path: '/encerramentoConta',
        view: 'HistoricoEncerramento',
        title: 'Contas Encerradas',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'historicostatuscartao',
        view: 'HistoricoStatusCartao',
        title: 'Bloqueio/Desbloqueio de Cartão',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'historicoreivindicacaodoacao',
        view: 'HistoricoReivindicacaoDoacao',
        title: 'Portabilidade PIX',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'historicosplit',
        view: 'HistoricoSplit',
        title: 'Split',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'historicofavorecidos',
        view: 'HistoricoFavorecidos',
        title: 'Favorecidos',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'analiseCadastral',
        view: 'HistoricoAnaliseCadastral',
        title: 'Análise Cadastral',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        path: 'permissaoAnaliseCadastral',
        view: 'HistoricoRelacaoOperadorPermissaoAnalise',
        title: 'Permissão Análise Cadastral',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Master],
          allRolesRequired: true
        }
      },
      {
        title: 'Solicitações Chave de Segurança',
        path: 'historicosolicitacoeschaveseguranca/',
        view: 'HistoricoSolicitacoesChaveSeguranca',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Seguranca],
          allRolesRequired: true
        }
      },
      {
        title: 'Solicitações Cartão',
        path: 'historicosolicitacaocartao/',
        view: 'HistoricoSolicitacaoCartao',
        menu: true,
        meta: {
          roles: [TipoPerfilOperador.Seguranca],
          allRolesRequired: true
        }
      }
    ]
  },
  {
    path: '/',
    view: 'Login',
    dir: 'views/',
    title: 'Login',
    menu: false,
    meta: {
      roles: TipoPerfilOperador.Nenhum,
      allRolesRequired: true
    }
  },
  {
    path: '/lembrar',
    view: 'Lembrar',
    dir: 'views/',
    title: 'Lembrar',
    menu: false,
    meta: {
      roles: TipoPerfilOperador.Nenhum,
      allRolesRequired: true
    }
  },
  {
    path: '/recuperar',
    view: 'Recuperar',
    dir: 'views/',
    title: 'Recuperar',
    params: true,
    menu: false,
    meta: {
      roles: TipoPerfilOperador.Nenhum,
      allRolesRequired: true
    }
  },
  {
    path: '/registrarmfafisico',
    view: 'RegistrarMfaFisico',
    dir: 'views/mfafisico/',
    title: 'Registrar MFA Físico',
    menu: false,
    meta: {
      roles: TipoPerfilOperador.Nenhum,
      allRolesRequired: true
    }
  }
]
